module.exports = __webpack_public_path__ + "Icon-africa.94f545435d7e093e977ce1038f4cce44.svg";